<template>
  <DSAssetTree
    :data
    :loading="isLoading"
    :formatter
    :active-path="activePath"
    hide-actions
    caption="Clients list"
    repo-name="All clients"
    search-placeholder="Find a client"
    @click:name="handleClickNode"
    @collapse="emit('collapse')"
  />
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'

import { AnalyticsField } from '@types'

import { ROUTE_NAME, SET_CURRENT_REPOSITORY, UNKNOWN_VALUE } from '@/const'

import { useAdvisorStore } from '@/store/advisor'

import { DSAssetTree } from '@ds'

const emit = defineEmits<{ collapse: [] }>()

const advisorStore = useAdvisorStore()

const router = useRouter()

const setCurrentRepository = inject<(id?: string) => void>(SET_CURRENT_REPOSITORY)

const clients = computed(() => advisorStore.getClients)
const totals = computed(() => advisorStore.getTotals)

const activePath = computed(() => {
  const path: string[] = [AnalyticsField.REPO_ROOT]
  const clientId = advisorStore.getSelectedClient
  if (clientId) {
    path.push(clientId)
  }
  return path
})

const data = computed(() => ({ [AnalyticsField.REPO_ROOT]: {
  ...Object.fromEntries(
    clients.value.map(client => [client.id, {
      path: [AnalyticsField.REPO_ROOT, client.id],
      balance: totals.value.get(client.id) || 0,
    }])),
  balance: advisorStore.getTotal,
}
}))
const isLoading = computed(() => advisorStore.loading)

const formatter = (key: string) =>
  clients.value.find(client => client.id === key)?.name || UNKNOWN_VALUE

const handleClickNode = (path: string[]) => {
  const clientId = path.at(-1)
  if (!clientId || clientId === AnalyticsField.REPO_ROOT) return
  setCurrentRepository?.(clientId)
  router.push({ name: ROUTE_NAME.DASHBOARDS })
}
</script>
